import { getViewAndUpdatePaymentMethodsCTA } from "./shared";
export var PaymentProcessingErrorIA = function PaymentProcessingErrorIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return PAYMENT_PROCESSING_ERROR(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [PAYMENT_PROCESSING_ERROR_INTRO(strictLocalize), ERROR_QUESTION_1(strictLocalize), ERROR_QUESTION_2(strictLocalize), ERROR_QUESTION_3(strictLocalize), ERROR_QUESTION_4(strictLocalize), UPDATE_PAYMENT_METHOD_USING_BUTTON(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewAndUpdatePaym;
        return (_getViewAndUpdatePaym = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym === void 0 ? void 0 : _getViewAndUpdatePaym.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewAndUpdatePaym2, _getViewAndUpdatePaym3;
        return (_getViewAndUpdatePaym2 = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym2 === void 0 ? void 0 : (_getViewAndUpdatePaym3 = _getViewAndUpdatePaym2.getLink) === null || _getViewAndUpdatePaym3 === void 0 ? void 0 : _getViewAndUpdatePaym3.call(_getViewAndUpdatePaym2);
      }
    }
  };
};
var PAYMENT_PROCESSING_ERROR = function PAYMENT_PROCESSING_ERROR(strictLocalize) {
  return strictLocalize({
    id: "Zc7b1J",
    defaultMessage: [{
      "type": 0,
      "value": "Erreurs de traitement des paiements"
    }]
  });
};
var PAYMENT_PROCESSING_ERROR_INTRO = function PAYMENT_PROCESSING_ERROR_INTRO(strictLocalize) {
  return strictLocalize({
    id: "30rp+E",
    defaultMessage: [{
      "type": 0,
      "value": "Si un problème technique bloque votre paiement, vérifiez les informations suivantes."
    }]
  });
};
var ERROR_QUESTION_1 = function ERROR_QUESTION_1(strictLocalize) {
  return strictLocalize({
    id: "PxlzZV",
    defaultMessage: [{
      "type": 0,
      "value": "1. L'adresse associée à la carte correspond-elle à l'adresse de votre compte ?"
    }]
  });
};
var ERROR_QUESTION_2 = function ERROR_QUESTION_2(strictLocalize) {
  return strictLocalize({
    id: "xuAvma",
    defaultMessage: [{
      "type": 0,
      "value": "2. Le nom figurant sur la carte est-il identique à celui indiqué sur votre compte Faire ?"
    }]
  });
};
var ERROR_QUESTION_3 = function ERROR_QUESTION_3(strictLocalize) {
  return strictLocalize({
    id: "Pl/KsG",
    defaultMessage: [{
      "type": 0,
      "value": "3. La carte est-elle expirée ?"
    }]
  });
};
var ERROR_QUESTION_4 = function ERROR_QUESTION_4(strictLocalize) {
  return strictLocalize({
    id: "T3m2gK",
    defaultMessage: [{
      "type": 0,
      "value": "4. La carte fait-elle l'objet d'alertes de la banque ?"
    }]
  });
};
var UPDATE_PAYMENT_METHOD_USING_BUTTON = function UPDATE_PAYMENT_METHOD_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "W0M5sq",
    defaultMessage: [{
      "type": 0,
      "value": "Vous pouvez modifier vos modes de paiement à l'aide du bouton ci-dessous. Si le problème persiste, contactez-nous. Lorsque vous nous écrivez, pensez à indiquer s'il s'agit d'une carte de débit ou de crédit."
    }]
  });
};